import { BaseDialog } from "./dialog"
import { useState } from "react"
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { toast } from "../ui/use-toast";
import { markOneTimeContractAsNeedChange } from "@/service/weexpertService";
import { Loader2 } from "lucide-react";

export default function NeedChangePopup({ contractId, onSuccess }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");

  const mutation = useMutation({
    mutationFn: (data) => markOneTimeContractAsNeedChange(contractId, data),
    onSuccess: () => {
      toast({
        title: "Sukces",
        description: "Umowa została oznaczona jako wymagająca zmian",
      });
      setOpen(false);
      setReason("");
      if (onSuccess) {
        onSuccess();
      }
      queryClient.invalidateQueries(['oneTimeContract', contractId]);
    },
    onError: (error) => {
      toast({
        title: "Błąd",
        description: error.response?.data?.message || "Nie udało się oznaczyć umowy jako wymagającej zmian",
        variant: "destructive",
      });
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!reason.trim()) {
      toast({
        title: "Błąd",
        description: "Musisz podać powód zmian",
        variant: "destructive",
      });
      return;
    }
    
    const data = {
      reason: reason.trim()
    };
    
    mutation.mutate(data);
  };

  const handleCancel = () => {
    setOpen(false);
    setReason("");
  };

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      buttonText="Oznacz jako wymagające zmian"
      dialogTitle="Oznacz umowę jako wymagającą zmian"
      className="bg-orange-600 text-white hover:bg-orange-700"
      ommitStyles={true}
    >
      <form onSubmit={handleSubmit} className="mt-4 space-y-4">
        <div className="space-y-2">
          <Label htmlFor="reason">Powód zmian *</Label>
          <Textarea
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Opisz, jakie zmiany są potrzebne w tej umowie..."
            rows={4}
            required
            disabled={mutation.isLoading}
          />
        </div>
        
        <div className="flex justify-end space-x-2 pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={handleCancel}
            disabled={mutation.isLoading}
          >
            Anuluj
          </Button>
          <Button
            type="submit"
            disabled={mutation.isLoading || !reason.trim()}
            className="bg-orange-600 hover:bg-orange-700"
          >
            {mutation.isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Oznaczanie...
              </>
            ) : (
              'Oznacz'
            )}
          </Button>
        </div>
      </form>
    </BaseDialog>
  )
}